import { Divider, Heading } from "@digdir/designsystemet-react";
import type { DetailedHTMLProps, HTMLAttributes } from "react";

export const MarkdownH1 = (
  props: DetailedHTMLProps<
    HTMLAttributes<HTMLHeadingElement>,
    HTMLHeadingElement
  >,
) => {
  return (
    <Heading level={1} data-size={"lg"} className="mb-6">
      {props.children}
    </Heading>
  );
};

export const MarkdownH2 = (
  props: DetailedHTMLProps<
    HTMLAttributes<HTMLHeadingElement>,
    HTMLHeadingElement
  >,
) => {
  return (
    <Heading level={2} data-size={"md"} className="mb-6">
      {props.children}
    </Heading>
  );
};

export const MarkdownH3 = (
  props: DetailedHTMLProps<
    HTMLAttributes<HTMLHeadingElement>,
    HTMLHeadingElement
  >,
) => {
  return (
    <Heading level={3} data-size="sm" className="mb-6">
      {props.children}
    </Heading>
  );
};

export const MarkdownH4 = (
  props: DetailedHTMLProps<
    HTMLAttributes<HTMLHeadingElement>,
    HTMLHeadingElement
  >,
) => {
  return (
    <Heading level={4} data-size="xs" className="mb-6">
      {props.children}
    </Heading>
  );
};

export const MarkdownH5 = (
  props: DetailedHTMLProps<
    HTMLAttributes<HTMLHeadingElement>,
    HTMLHeadingElement
  >,
) => {
  return (
    <Heading level={5} data-size="2xs" className="mb-6">
      {props.children}
    </Heading>
  );
};

export const MarkdownHr = (
  _: DetailedHTMLProps<HTMLAttributes<HTMLHRElement>, HTMLHRElement>,
) => {
  return <Divider className="my-8" />;
};
